// extracted by mini-css-extract-plugin
module.exports = {"slider_text_wrapper":"search_slider_text_wrapper__XdqPv","common":"search_common__DxOPI","slideUp":"search_slideUp__1Tbzo"};